<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'550'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Número Processo
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Escreva um processo para a requisição {{requisicaoEditar.id}}:
                </span>

                <br>
                <br>

                <v-text-field label="Processo" :name="'Processo id ' + requisicaoEditar.id" class="required-field"
                              :key="'Processo id '  + requisicaoEditar.id" placeholder="Ex. 1A2B3C2021"
                              :error-messages="errors.collect('Processo id '  + requisicaoEditar.id)"
                              v-model="processo" v-validate="'required'" maxlength="25" :counter="25"/>

            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalEditarProcessoRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            processo: null
        }
    },
    mounted(){
        this.processo = this.requisicaoEditar.numeroProcesso
    },
    methods:{
        confirmar() {
            if(!this.processo || this.processo.trim().length === 0 ){
                throw new Error('Processo não informado!')
            }
            this.requisicaoEditar.numeroProcesso = this.processo
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
